import { authContext, hasPermission, IPermissions } from 'entities/user';
import { useContext } from 'react';

export const usePermission = (permission: keyof IPermissions) => {
    const userInfo = useContext(authContext);
    return hasPermission(userInfo?.roles, permission)
};
